module.exports = __webpack_public_path__ + "img/br46.2d0d814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br46.jpg
// module id = nG+5
// module chunks = 0